import { Page } from '@dixa/lib-shared-habla';
import { Outlet } from 'react-router-dom';

import { SettingsIntegrationsPageHeader } from './components/pageHeader';

export const SettingsIntegrationsView = (): JSX.Element => {
  return (
    <Page>
      <SettingsIntegrationsPageHeader />

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
